import { useStats } from '../hooks/useApi'

export default function StatsCards() {
  const { data: stats, loading, error } = useStats()

  if (loading) {
    return (
      <div className="row mb-3">
        {Array.from({ length: 4 }, (_, i) => `skeleton-stat-${Date.now()}-${i}`).map(key => (
          <div key={key} className="col-md-3">
            <div className="card">
              <div className="card-body py-2 px-3">
                <div className="placeholder-glow">
                  <span className="placeholder col-4" />
                  <span className="placeholder col-6" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        統計情報読み込みエラー: {error}
      </div>
    )
  }

  return (
    <div className="row mb-3">
      <div className="col-md-3">
        <div className="card">
          <div className="card-body py-2 px-3">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <div className="text-muted small mb-1">端末総数</div>
                <div className="h5 mb-0 fw-bold">{stats?.total_devices ?? 0}</div>
              </div>
              <div className="text-primary">
                <i className="fas fa-microchip fa-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card">
          <div className="card-body py-2 px-3">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <div className="text-muted small mb-1">オンライン</div>
                <div className="h5 mb-0 fw-bold text-success">{stats?.active_devices ?? 0}</div>
              </div>
              <div className="text-success">
                <i className="fas fa-check-circle fa-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card">
          <div className="card-body py-2 px-3">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <div className="text-muted small mb-1">総ログ数</div>
                <div className="h5 mb-0 fw-bold text-info">
                  {stats?.total_logs.toLocaleString() ?? 0}
                </div>
              </div>
              <div className="text-info">
                <i className="fas fa-file-alt fa-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card">
          <div className="card-body py-2 px-3">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <div className="text-muted small mb-1">今日のログ</div>
                <div className="h5 mb-0 fw-bold text-warning">
                  {stats?.logs_today.toLocaleString() ?? 0}
                </div>
              </div>
              <div className="text-warning">
                <i className="fas fa-calendar-day fa-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
